import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { Text, tokens } from '@hotjar/hotsauce';
import { CheckboxGroup } from '@hotjar/webapp/components/CheckboxGroup';

const Container = styled.article`
  margin-bottom: ${tokens.spacer.x3};
`;

const SelectQuestionsHeader = styled(Text)`
  display: block;
  margin-top: ${tokens.spacer.x1};
  margin-bottom: ${tokens.spacer.x2};
`;

type QuestionId = string;

type Question = {
  value: QuestionId;
  label: string;
};

interface QuestionsFormProps {
  all: Array<Question>;
  selected: Array<QuestionId>;
  onChange: (selected: Array<QuestionId>) => void;
  integrationName: string;
}

export const QuestionsForm = ({
  all,
  selected,
  onChange,
  integrationName,
}: QuestionsFormProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Container>
      <SelectQuestionsHeader textType="subtitle2">
        {t('common:survey.creation.forwarding.select-questions', { name: integrationName })}
      </SelectQuestionsHeader>
      <CheckboxGroup
        options={all}
        value={selected}
        onChange={onChange}
        minChecked={1}
        minCheckedTooltip={t('common:survey.creation.forwarding.min-questions-tooltip')}
      />
    </Container>
  );
};
